export default __webpack_public_path__ + "static/media/boys-top.94acd10f.png";